module.exports = __webpack_public_path__ + "static/media/right_girl.4170bf3e.png";